import React from 'react';
import Searchbar from './Searchbar';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import Filter from './Filter';
import ViewController from './ViewController';
import BulkController from './BulkController';

const Controller = ({ filter, term, handleSearch, toggleForm, handleFilter, view, handleView, deleteCompleted, deleteSelected, reset }) => {
    return (
        <div>
            <Searchbar term={term} handleSearch={handleSearch} toggleForm={toggleForm} />
            <Row className="d-flex my-3" >
                <Col md={{ size: 4 }}>
                    <Filter handleFilter={handleFilter} filter={filter} />
                </Col>
                <Col md={{ size: 4 }}>
                    <ViewController view={view} handleView={handleView} />
                </Col>
                <Col md={{ size: 4 }}>
                    <BulkController deleteCompleted={deleteCompleted} deleteSelected={deleteSelected} reset={reset} />
                </Col>
            </Row>
        </div>
    );
};

Controller.propTypes = {
    term: PropTypes.string.isRequired,
    handleSearch: PropTypes.func.isRequired,
    toggleForm: PropTypes.func.isRequired,
    handleForm: PropTypes.func.isRequired,
    handleFilter: PropTypes.func.isRequired,
    view: PropTypes.string.isRequired,
    handleView: PropTypes.func.isRequired,
    deleteCompleted: PropTypes.func.isRequired,
    deleteSelected: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired
};

export default Controller;